import * as Yup from 'yup';

export function initialValues(user) {
    return {
        firstName: user?.firstName || "",
        lastName: user?.lastName || "",
        email: user?.email || "",
        password: user?.password || "",
        role: user?.role|| "",
    };
}

export function validationSchema(user) {
    return Yup.object({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        email: Yup.string().email("Format email invalid").required("Required"),
        password: Yup.string().required("Required"),
        role: Yup.string().required("Required"),
    });
}